export const _defaultFonts = [
  {
    googleName: 'ABeeZee',
    styleName: 'ABeeZee',
    fontWeight: '400',
  },
  {
    googleName: 'Abril+Fatface',
    styleName: 'Abril Fatface',
    fontWeight: '400',
  },
  {
    googleName: 'Acme',
    styleName: 'Acme',
    fontWeight: '400',
  },
  {
    googleName: 'Alegreya:400,700',
    styleName: 'Alegreya',
    fontWeight: '400',
  },
  {
    googleName: 'Alegreya+Sans:400,700',
    styleName: 'Alegreya Sans',
    fontWeight: '400',
  },
  {
    googleName: 'Anton',
    styleName: 'Anton',
    fontWeight: '400',
  },
  {
    googleName: 'Arimo:400,700',
    styleName: 'Arimo',
    fontWeight: '400',
  },
  {
    googleName: 'Arizonia',
    styleName: 'Arizonia',
    fontWeight: '400',
  },
  {
    googleName: 'Arvo:400,700',
    styleName: 'Arvo',
    fontWeight: '400',
  },
  {
    googleName: 'Baloo+Bhaina',
    styleName: 'Baloo Bhaina',
    fontWeight: '400',
  },
  {
    googleName: 'Bitter:400,700',
    styleName: 'Bitter',
    fontWeight: '400',
  },
  {
    googleName: 'Cabin:400,700',
    styleName: 'Cabin',
    fontWeight: '400',
  },
  {
    googleName: 'Cherry+Swash:400,700',
    styleName: 'Cherry Swash',
    fontWeight: '400',
  },
  {
    googleName: 'Courgette',
    styleName: 'Courgette',
    fontWeight: '400',
  },
  {
    googleName: 'Crimson+Text:400,700',
    styleName: 'Crimson Text',
    fontWeight: '400',
  },
  {
    googleName: 'Diplomata+SC',
    styleName: 'Diplomata SC',
    fontWeight: '400',
  },
  {
    googleName: 'Domine:400,700',
    styleName: 'Domine',
    fontWeight: '400',
  },
  {
    googleName: 'Dosis:400,700',
    styleName: 'Dosis',
    fontWeight: '400',
  },
  {
    googleName: 'Exo:400,700',
    styleName: 'Exo',
    fontWeight: '400',
  },
  {
    googleName: 'Fira+Sans:400,700',
    styleName: 'Fira Sans',
    fontWeight: '400',
  },
  {
    googleName: 'Fjalla+One',
    styleName: 'Fjalla One',
    fontWeight: '400',
  },
  {
    googleName: 'Gentium+Basic:400,700',
    styleName: 'Gentium Basic',
    fontWeight: '400',
  },
  {
    googleName: 'Grand+Hotel',
    styleName: 'Grand Hotel',
    fontWeight: '400',
  },
  {
    googleName: 'Gravitas+One',
    styleName: 'Gravitas One',
    fontWeight: '400',
  },
  {
    googleName: 'Inconsolata:400,700',
    styleName: 'Inconsolata',
    fontWeight: '400',
  },
  {
    googleName: 'Indie+Flower',
    styleName: 'Indie Flower',
    fontWeight: '400',
  },
  {
    googleName: 'Josefin+Sans:400,700',
    styleName: 'Josefin Sans',
    fontWeight: '400',
  },
  {
    googleName: 'Karla:400,700',
    styleName: 'Karla',
    fontWeight: '400',
  },
  {
    googleName: 'Kreon:400,700',
    styleName: 'Kreon',
    fontWeight: '400',
  },
  {
    googleName: 'Krona+One',
    styleName: 'Krona One',
    fontWeight: '400',
  },
  {
    googleName: 'Lato:400,700',
    styleName: 'Lato',
    fontWeight: '400',
  },
  {
    googleName: 'League+Script',
    styleName: 'League Script',
    fontWeight: '400',
  },
  {
    googleName: 'Libre+Baskerville:400,700',
    styleName: 'Libre Baskerville',
    fontWeight: '400',
  },
  {
    googleName: 'Libre+Franklin:400,700',
    styleName: 'Libre Franklin',
    fontWeight: '400',
  },
  {
    googleName: 'Lobster',
    styleName: 'Lobster',
    fontWeight: '400',
  },
  {
    googleName: 'Lora:400,700',
    styleName: 'Lora',
    fontWeight: '400',
  },
  {
    googleName: 'Luckiest+Guy',
    styleName: 'Luckiest Guy',
    fontWeight: '400',
  },
  {
    googleName: 'Merriweather:400,700',
    styleName: 'Merriweather',
    fontWeight: '400',
  },
  {
    googleName: 'Montserrat:400,700',
    styleName: 'Montserrat',
    fontWeight: '400',
  },
  {
    googleName: 'Mrs+Sheppards',
    styleName: 'Mrs Sheppards',
    fontWeight: '400',
  },
  {
    googleName: 'Neuton:400,700',
    styleName: 'Neuton',
    fontWeight: '400',
  },
  {
    googleName: 'Niconne',
    styleName: 'Niconne',
    fontWeight: '400',
  },
  {
    googleName: 'Noto+Sans:400,700',
    styleName: 'Noto Sans',
    fontWeight: '400',
  },
  {
    googleName: 'Nunito:400,700',
    styleName: 'Nunito',
    fontWeight: '400',
  },
  {
    googleName: 'Open+Sans:400,700',
    styleName: 'Open Sans',
    fontWeight: '400',
  },
  {
    googleName: 'Oswald:400,700',
    styleName: 'Oswald',
    fontWeight: '400',
  },
  {
    googleName: 'Oxygen:400,700',
    styleName: 'Oxygen',
    fontWeight: '400',
  },
  {
    googleName: 'Pacifico',
    styleName: 'Pacifico',
    fontWeight: '400',
  },
  {
    googleName: 'Paytone+One',
    styleName: 'Paytone One',
    fontWeight: '400',
  },
  {
    googleName: 'Playball',
    styleName: 'Playball',
    fontWeight: '400',
  },
  {
    googleName: 'Playfair+Display:400,700',
    styleName: 'Playfair Display',
    fontWeight: '400',
  },
  {
    googleName: 'Poppins:400,700',
    styleName: 'Poppins',
    fontWeight: '400',
  },
  {
    googleName: 'PT+Mono',
    styleName: 'PT Mono',
    fontWeight: '400',
  },
  {
    googleName: 'PT+Sans:400,700',
    styleName: 'PT Sans',
    fontWeight: '400',
  },
  {
    googleName: 'PT+Serif:400,700',
    styleName: 'PT Serif',
    fontWeight: '400',
  },
  {
    googleName: 'Quattrocento+Sans:400,700',
    styleName: 'Quattrocento Sans',
    fontWeight: '400',
  },
  {
    googleName: 'Qwigley',
    styleName: 'Qwigley',
    fontWeight: '400',
  },
  {
    googleName: 'Raleway:400,700',
    styleName: 'Raleway',
    fontWeight: '400',
  },
  {
    googleName: 'Roboto:400,700',
    styleName: 'Roboto',
    fontWeight: '400',
  },
  {
    googleName: 'Roboto+Condensed:400,700',
    styleName: 'Roboto Condensed',
    fontWeight: '400',
  },
  {
    googleName: 'Roboto+Slab:400,700',
    styleName: 'Roboto Slab',
    fontWeight: '400',
  },
  {
    googleName: 'Rokkitt:400,700',
    styleName: 'Rokkitt',
    fontWeight: '400',
  },
  {
    googleName: 'Sacramento',
    styleName: 'Sacramento',
    fontWeight: '400',
  },
  {
    googleName: 'Sail',
    styleName: 'Sail',
    fontWeight: '400',
  },
  {
    googleName: 'Sedgwick+Ave+Display',
    styleName: 'Sedgwick Ave Display',
    fontWeight: '400',
  },
  {
    googleName: 'Shadows+Into+Light',
    styleName: 'Shadows Into Light',
    fontWeight: '400',
  },
  {
    googleName: 'Sigmar+One',
    styleName: 'Sigmar One',
    fontWeight: '400',
  },
  {
    googleName: 'Six+Caps',
    styleName: 'Six Caps',
    fontWeight: '400',
  },
  {
    googleName: 'Slabo+27px',
    styleName: 'Slabo 27px',
    fontWeight: '400',
  },
  {
    googleName: 'Source+Code+Pro:400,700',
    styleName: 'Source Code Pro',
    fontWeight: '400',
  },
  {
    googleName: 'Stalemate',
    styleName: 'Stalemate',
    fontWeight: '400',
  },
  {
    googleName: 'Titillium+Web:400,700',
    styleName: 'Titillium Web',
    fontWeight: '400',
  },
  {
    googleName: 'Tulpen+One',
    styleName: 'Tulpen One',
    fontWeight: '400',
  },
  {
    googleName: 'Ubuntu:400,700',
    styleName: 'Ubuntu',
    fontWeight: '400',
  },
  {
    googleName: 'Ultra',
    styleName: 'Ultra',
    fontWeight: '400',
  },
  {
    googleName: 'Unica+One',
    styleName: 'Unica One',
    fontWeight: '400',
  },
  {
    googleName: 'Vollkorn:400,700',
    styleName: 'Vollkorn',
    fontWeight: '400',
  },
  {
    googleName: 'Work+Sans:400,700',
    styleName: 'Work Sans',
    fontWeight: '400',
  },
  {
    googleName: 'Yellowtail',
    styleName: 'Yellowtail',
    fontWeight: '400',
  },
];

export const _oldFont = [
  'Aclonica',
  'Allan',
  'Annie+Use+Your+Telescope',
  'Anonymous+Pro',
  'Allerta+Stencil',
  'Allerta',
  'Amaranth',
  'Anton',
  'Architects+Daughter',
  'Arimo',
  'Artifika',
  'Arvo',
  'Asset',
  'Astloch',
  'Bangers',
  'Bentham',
  'Bevan',
  'Bigshot+One',
  'Bowlby+One',
  'Bowlby+One+SC',
  'Brawler',
  'Buda:300',
  'Cabin',
  'Calligraffitti',
  'Candal',
  'Cantarell',
  'Cardo',
  'Carter One',
  'Caudex',
  'Cedarville+Cursive',
  'Cherry+Cream+Soda',
  'Chewy',
  'Coda',
  'Coming+Soon',
  'Copse',
  'Corben',
  'Cousine',
  'Covered+By+Your+Grace',
  'Crafty+Girls',
  'Crimson+Text',
  'Crushed',
  'Cuprum',
  'Damion',
  'Dancing+Script',
  'Dawning+of+a+New+Day',
  'Didact+Gothic',
  'Droid+Sans',
  'Droid+Sans+Mono',
  'Droid+Serif',
  'EB+Garamond',
  'Expletus+Sans',
  'Fontdiner+Swanky',
  'Forum',
  'Francois+One',
  'Geo',
  'Give+You+Glory',
  'Goblin+One',
  'Gravitas+One',
  'Gruppo',
  'Hammersmith+One',
  'Holtwood+One+SC',
  'Homemade+Apple',
  'Inconsolata',
  'Indie+Flower',
  'IM+Fell+DW+Pica',
  'IM+Fell+DW+Pica+SC',
  'IM+Fell+Double+Pica',
  'IM+Fell+Double+Pica+SC',
  'IM+Fell+English',
  'IM+Fell+English+SC',
  'IM+Fell+French+Canon',
  'IM+Fell+French+Canon+SC',
  'IM+Fell+Great+Primer',
  'IM+Fell+Great+Primer+SC',
  'Irish+Grover',
  'Irish+Growler',
  'Istok+Web',
  'Josefin+Sans',
  'Josefin+Slab',
  'Judson',
  'Jura',
  'Just+Another+Hand',
  'Just+Me+Again+Down+Here',
  'Kameron',
  'Kenia',
  'Kranky',
  'Kreon',
  'Kristi',
  'La+Belle+Aurore',
  'Lato',
  'League+Script',
  'Lekton',
  'Limelight',
  'Lobster',
  'Lobster Two',
  'Lora',
  'Love+Ya+Like+A+Sister',
  'Loved+by+the+King',
  'Luckiest+Guy',
  'Maiden+Orange',
  'Mako',
  'Maven+Pro',
  'Meddon',
  'MedievalSharp',
  'Megrim',
  'Merriweather',
  'Metrophobic',
  'Michroma',
  'Miltonian Tattoo',
  'Miltonian',
  'Modern Antiqua',
  'Molengo',
  'Mountains of Christmas',
  'Muli',
  'Neucha',
  'Neuton',
  'News+Cycle',
  'Nixie+One',
  'Nobile',
  'Nova+Cut',
  'Nova+Flat',
  'Nova+Mono',
  'Nova+Oval',
  'Nova+Round',
  'Nova+Script',
  'Nova+Slim',
  'Nova+Square',
  'Nunito',
  'OFL+Sorts+Mill+Goudy+TT',
  'Old+Standard+TT',
  'Open+Sans',
  'Open+Sans+Condensed:300',
  'Orbitron',
  'Oswald',
  'Over+the+Rainbow',
  'Reenie+Beanie',
  'Pacifico',
  'Parisienne',
  'Patrick+Hand',
  'Paytone+One',
  'Permanent+Marker',
  'Philosopher',
  'Play',
  'Playfair+Display',
  'Podkova',
  'PT+Sans',
  'PT+Sans+Narrow',
  'PT+Serif',
  'PT+Serif Caption',
  'Puritan',
  'Quattrocento',
  'Quattrocento+Sans',
  'Radley',
  'Raleway:100',
  'Redressed',
  'Rock+Salt',
  'Roboto',
  'Rokkitt',
  'Ruslan+Display',
  'Schoolbell',
  'Shadows+Into+Light',
  'Shanti',
  'Sigmar+One',
  'Six+Caps',
  'Slackey',
  'Smythe',
  'Sniglet:800',
  'Special+Elite',
  'Stardos+Stencil',
  'Sue+Ellen+Francisco',
  'Sunshiney',
  'Swanky+and+Moo+Moo',
  'Syncopate',
  'Tangerine',
  'Tenor+Sans',
  'Terminal+Dosis+Light',
  'The+Girl+Next+Door',
  'Tinos',
  'Ubuntu',
  'Ultra',
  'Unkempt',
  'UnifrakturCook:bold',
  'UnifrakturMaguntia',
  'Varela',
  'Varela Round',
  'Vibur',
  'Vollkorn',
  'VT323',
  'Waiting+for+the+Sunrise',
  'Wallpoet',
  'Walter+Turncoat',
  'Wire+One',
  'Yanone+Kaffeesatz',
  'Yeseva+One',
  'Zeyada',
];
